import React, { PropsWithChildren } from "react";
import { Link, useLocation } from "react-router-dom";

type Props = {
  rootUrl: string;
  rootName: string;
}

type CrumbProps = {
  path: string;
  text: string;
}

export const Crumb: React.FC<CrumbProps> = (props) =>
  <span className="Breadcrumb">&nbsp; &gt; &nbsp;{props.text}</span>;

export const Breadcrumbs: React.FC<PropsWithChildren<Props>> = (props) => {
  const location = useLocation();
  const root = props.rootUrl.endsWith("/") ? props.rootUrl.slice(0, -1) : props.rootUrl;
  const relativePath = location.pathname.startsWith(root) ? (
    location.pathname.slice(root.length).replace(/^\//, "")
  ) : "";
  const [activeSegment] = relativePath.split("/") || [];

  const activeCrumb = React.Children.toArray(props.children).find((child) => {
    if (!React.isValidElement(child)) return false;
    // @ts-ignore reading path prop from Crumb
    const pathProp = child.props?.path as string | undefined;
    if (!pathProp) return false;
    if (pathProp === "/" && (activeSegment === "" || activeSegment === "/")) return true;
    return pathProp === activeSegment;
  });

  return (
    <div className="BreadcrumbContainer">
      <div className="container max-960">
        <span className="Breadcrumb">
          <b>
            <Link to={props.rootUrl}>{props.rootName}</Link>
          </b>
        </span>

        <span style={{ display: "inline-block" }}>
          {activeCrumb}
        </span>
      </div>
    </div>
  );
};
